<template>
	<div class="page">
		<top-header></top-header>
		<b-container fluid style="margin-top:5%">
			<b-row class="mt-3 mb-2">
				<b-col class="col-md-6 col-sm-6 col-xs-6">
					<h3>Uptime Daily Cumulative Report</h3>
				</b-col>
				<b-col class="col-md-6 col-sm-6 col-xs-6 text-right">
					<b-button variant="dark" pill class="mr-2" size="sm" @click="showDeviceReportModal()">Choose Device</b-button>
				</b-col>
			</b-row>
			<!-- <b-row class="mt-3 mb-2">
				<b-col >
					<small>{{deviceName}}</small>
			</b-col>
			</b-row> -->
		</b-container>
		<b-container fluid>
			<b-row>
				<b-col class="col-md-12 col-sm-12 col-xs-12">
					<div style="border-top: 3px solid #333; border-radius: 5px; min-height: 100px; background-color: #FFF; display: flex; flex-direction: column;">
						<b-row class="mt-4 px-3 mb-3">
							<b-col lg="4">
								<label class="mr-2">Show</label>
								<b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">
								</b-form-select>
								<span class="ml-2">entries</span>  
							</b-col>
							<b-col lg="3" class="text-center"><p class="p-0 m-0">
								<b>Uptime % : </b>{{ records.length>0?(total_uptime/records.length).toFixed(2):0 }}</p>
								<small v-if="selectedItem.end_date">(Between {{$moment(selectedItem.start_date).format('DD-MM-YYYY')}} To  {{$moment(selectedItem.end_date).format('DD-MM-YYYY')}})</small>
							</b-col>
							<b-col lg="4"  class="text-right">
								<!-- <b-button variant="dark" pill  size="sm" class="mr-2" @click="downloadPDF()">Download PDF</b-button> -->
								<b-button variant="dark" pill size="sm" @click="downloadcsv()">Download xlsx</b-button>
							</b-col>
						</b-row>
						<b-row class="px-3">
							<b-col lg="12">
								<!-- <b-table show-empty sticky-header small striped outlined stacked="md" :items="records" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :filterIncludedFields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered">-->
								<b-table 
                    show-empty
                    sticky-header
                    responsive
                    outlined
                    caption-top
                    hover
                    head-variant="dark"
                    borderless="borderless"
                    id="my-table-live"
                    stacked="md"
                    stickyColumn="scrolled"
               
                    :items="records"                  
                    :fields="fields"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :filter="filter"
                    :filterIncludedFields="filterOn"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :sort-direction="sortDirection"
                    @filtered="onFiltered"
                    class="scrollH d-flex" 
                  >

									<template v-slot:cell(output_status)="row">
										<b-badge pill variant="success" v-if="row.value == 1">ON</b-badge>
										<b-badge pill variant="danger" v-else>OFF</b-badge>
									</template>
									<template v-slot:cell(supply)="row">
										<img src="../assets/power-on.svg" v-if="row.value == 'ON'" style="max-width:20px; max-height:20px;">
										<img src="../assets/power-off.svg" v-else style="max-width:20px; max-height:20px;">
									</template>
									<template v-slot:cell(door_status)="row">
										<b-badge pill variant="danger" v-if="row.value == 1">OPENED</b-badge>
										<b-badge pill variant="success" v-else>CLOSED</b-badge>
									</template>
								</b-table>
							</b-col>
						</b-row>
						<b-row class="px-3 mb-3">
							<b-col lg="6">
								<span class="mr-2">Showing {{(currentPage-1)*perPage}} to {{currentPage*perPage}} of {{records.length}} entries</span>
							</b-col>
							<b-col lg="6">
								<b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
			<b-row>
				<b-col> 
					<UptimeChart v-if="records.length>0" :apiData="apiResponse" />
				</b-col>
			</b-row>

            <b-modal id="my-model" title="Choose Date" ok-only @hidden="resetSelectedItem" @ok="modalSubmit">
				<form ref="form" @submit.stop.prevent="handleSubmit">
					
					  <!-- <b-form-group label="Location" label-cols="3" label-size="sm" label-align-sm="right" class="p-0">
						<VSelect v-model="wardfilter" :options="wardfilterlist" :searchable="true" defaultTitle="Choose Location" size="sm" class=" w-20 custom-select custom-select-sm ml-2" @input="onWardChangeward()" >
                      </VSelect>
                    </b-form-group> -->

                 
                    <b-form-group label="Start Date" label-cols="3" label-size="sm" label-align-sm="right">
						<b-form-datepicker v-model="selectedItem.start_date" :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit', weekday: 'short' }" :hide-header="true"></b-form-datepicker>
					</b-form-group>
					<b-form-group label="End Date" label-cols="3" label-size="sm" label-align-sm="right">
						<b-form-datepicker v-model="selectedItem.end_date" :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit', weekday: 'short' }" :hide-header="true"></b-form-datepicker>
					</b-form-group>
					<!-- <b-form-group
										label=""
										label-cols="3"
										label-align-sm="right"
										label-size="sm"
										>
										<b-form-checkbox
											v-model="selectedItem.schedule"
											:value="1"
											:unchecked-value="0"
											size="sm"
										>
											Night
										</b-form-checkbox>
										</b-form-group> -->
				</form>
				<template v-slot:modal-footer="{ ok, close }">
					<b-button size="sm" variant="danger" @click="close()">Cancel</b-button>
					<b-button size="sm" variant="success" @click="ok()">Submit</b-button>
				</template>
			</b-modal>
            
		</b-container>
        <transition name="fade">
			<b-row v-if="loading" class="loading" style="position: fixed; top:0px; left:0px; right:0px; bottom:0px; z-index: 1000; background-color: rgba(0,0,0,0.4);" align-v="center" align-h="center">
				<b-spinner label="Busy" variant="light"></b-spinner>
			</b-row>
		</transition>
	</div>
</template>
<script>
import Header from "@/components/Header.vue";
import UptimeChart  from "@/components/Uptime_chart.vue";
import * as XLSX from "xlsx-js-style";

//import VSelect from "vue-select-picker-bootstrap";
export default {
	name: 'Devices',
	components: {
		"top-header": Header,
	//	VSelect,
		UptimeChart
	},
	mounted(){
		this.initload();
	},
	data() {
		var self = this;
		return{
			email: '',
			password: '',
            loading: false,
			url: self.$session.get('apiurl')+'esmartapi/uptime-cumulative-report',
			wardUrl: self.$session.get('apiurl')+'esmartapi/ward-wise-imei',			
			imeino: self.$route.params.imeino,
			location: '',
			filterselected: '',
			apiResponse:{},
			records: [],
			wardrecords:[],
			device: {},
			fields: [ 
			    { key: 'sr_no', label: 'SNo.', sortable: true, sortDirection: 'desc' },
				/* { key: 'feeder_pillar_no', label: 'FP No.', sortable: true, sortDirection: 'desc' },	 */				
				{ key: 'report_date', label: 'Date', sortable: true, sortDirection: 'desc',
					formatter: (value) => {
						//var self = this;
						//console.log(key+'--'+item.update_time);						
							return self.$moment(value).format('DD-MM-YYYY');

							/* const duration = self.$moment.duration(value, 'seconds');

								const days = duration.days();
								const hours = duration.hours();
								const minutes = duration.minutes();
								const seconds = duration.seconds();

								const formatted = `${days} Days ${hours} Hours ${minutes} Minutes ${seconds} Seconds`;

								return formatted; */
												
					},
				 },	
				 { key: 'month', label: 'Month', sortable: true, sortDirection: 'desc' },
				  { key: 'year', label: 'Year', sortable: true, sortDirection: 'desc' },
				  { key: 'uptime_percent', label: 'Uptime %', sortable: true, sortDirection: 'desc' },			
				
				
				/* { key: 'light_data', label: 'Thread', sortable: true ,
					formatter: (value) => {
						//var self = this;
						//console.log(key+'--'+item.update_time);
						if(value!=null && value!='null'){
							var lightData = JSON.parse(value);
							return lightData.thread; //self.$moment(item.update_time).format('DD-MM-YYYY HH:mm:ss');
						}else{
							return 0;
						}
					}, 
				}, */
				
			],
			totalRows: 1,
			currentPage: 1,
			pageOptions: [10, 20, 50, 100],
			perPage: 10,
			sortBy: '',
			sortDesc: false,
			sortDirection: 'asc',
			filter: null,
			filterOn: [],
            selectedItem: {},
			emptyItem: {
				id: 0,
                imei_no: '',
                feeder_pillar_no: '',
				start_date: '',
                end_date: ''
			},
			deviceName:'',
			wardfilter:'all',
			wardfilterlist:[],
			imei_noOptionsfilter:[],
			fpn_noOptionsfilter:[],
			warddataListarray_imei:[],
			warddataListarray_fon:[],
			total_uptime:0,
		};
	},
	methods: {
        showDeviceReportModal() {
           // this.selectedItem = Object.assign({}, this.emptyItem);
			this.$root.$emit('bv::show::modal', 'my-model');
		},
        resetSelectedItem(){
			/* var self = this;
			self.selectedItem = Object.assign({}, self.emptyItem); */
		},
        modalSubmit(bvModalEvt){
			var self = this;
			self.total_uptime =0;
			self.loading = true;
			bvModalEvt.preventDefault();

			self.filterselected = self.selectedItem;
            
			self.axios.post(self.url, {
				accesskey: self.$session.get('access_key'),
				data: self.selectedItem
			})
			.then(function (response) {
                self.loading = false;
				if(response.data.error == 0 || response.data.error == '0'){
                    var tmparr = response.data.result.records;
 
					//self.apiResponse = response;
					

					//var devideDetails = response.data.result.devideDetails;
					//self.deviceName = '(Location:'+devideDetails.location+') | FPNo:'+devideDetails.feeder_pillar_no ;
				
                    
					var sr_no =1;
					tmparr.forEach(function(field){
						/* if(field.datalength == 59){
							field.supply = 'OFF';
						}else{
							field.supply = "ON";
						} */
						self.total_uptime+= field.uptime_percent;
						field.month = self.$moment(field.report_date).format("MMMM");
						field.year = self.$moment(field.report_date).format("Y");
						field.sr_no = sr_no;

						sr_no++;

					});
					self.apiResponse = response.data;
					self.records = tmparr;

					self.totalRows = self.records.length;

                    self.$bvModal.hide('my-model');
                    self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
					});
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
		},initload() {
			var self = this;
			self.axios
				.post(self.wardUrl, {
					accesskey: self.$session.get("access_key"),
				})
				.then(function(response) {
				if (response.data.error == 0 || response.data.error == "0") {
					//var filteredarr = self.filtercategory(response.data.result);

					self.wardrecords = response.data.result;
					self.warddataListarray_imei={};
					self.warddataListarray_fon={};
					self.wardfilterlist=[];
					self.wardfilterlist.push({'value':'','text':''});
					self.wardfilterlist.push({'value':'all','text':'All Device'});
					self.wardrecords.forEach(function(row){
						if(row.ward_id!=''){
						var supList ={'value':row.fpn,'text':'#'+row.fpn+' '+row.title};
						self.wardfilterlist.push(supList);
						console.log(row.fpn,row.imei_no);
						self.warddataListarray_imei[row.ward_id]=row.imei_no;
						self.warddataListarray_fon[row.ward_id]=row.fpn;
						}
						//self.warddataListarray_imei.push
						
					});

					



					
				}
				})
				.catch(function(error) {
				alert(error);
				});
			//alert('login '+self.email+" "+self.password);
		},
		onFiltered(filteredItems) {
			// Trigger pagination to update the number of buttons/pages due to filtering
			this.totalRows = filteredItems.length
			this.currentPage = 1
		},
		downloadcsv() {
    var self = this;

    // 👉 Prepare Header
    var header = [];
    self.fields.forEach(function(item){
        if(!item.extra){
            header.push(item.label);
        }
    });

    let data = [];

    // 👉 Row 1: Title
    data.push(["Uptime Daily Cumulative Report"]);
	var utp = this.records.length>0?(this.total_uptime/this.records.length).toFixed(2):0;
    // 👉 Row 2: Date (optional dynamic)
    data.push(["Uptime %:"+utp]);

    // 👉 Empty Row
    data.push([]);

    // 👉 Header Row
    data.push(header);

    // 👉 Data Rows (YOUR SAME LOGIC)
    self.records.forEach(function(row){
        var dataarr = [];

        self.fields.forEach(function(field){
            if(field.key != 'extra'){
                var fieldData = row[field.key];

                if(field.key =='light_data'){
                    var value = row[field.key];
                    var threadValue = 0;
                    if(value!=null && value!='null'){
                        var lightData = JSON.parse(value);                            
                        threadValue = lightData.thread; 
                    }
                    fieldData = threadValue;
                }

                if(field.key == 'output_status'){
                    fieldData = fieldData == 1 ? "ON" : "OFF";
                }

                if(field.key == 'door_status'){
                    fieldData = fieldData == 1 ? "OPEN" : "CLOSED";
                }

                dataarr.push(fieldData);
            }
        });

        data.push(dataarr);
    });

    // 👉 Create Sheet
    const ws = XLSX.utils.aoa_to_sheet(data);

    // ✅ Merge Title & Date
    ws['!merges'] = [
        { s: { r: 0, c: 0 }, e: { r: 0, c: header.length - 1 } },
        { s: { r: 1, c: 0 }, e: { r: 1, c: header.length - 1 } }
    ];

    // ✅ Title Style
    ws["A1"].s = {
        alignment: { horizontal: "center", vertical: "center" },
        font: { bold: true, sz: 16 }
    };

    // ✅ Date Style
    ws["A2"].s = {
        alignment: { horizontal: "center" },
        font: { sz: 12 }
    };

    // ✅ Header Style
    header.forEach((_, colIndex) => {
        let cell = XLSX.utils.encode_cell({ r: 3, c: colIndex });
        if (ws[cell]) {
            ws[cell].s = {
                alignment: { horizontal: "left" },
                font: { bold: true },
                border: {
                    top: { style: "thin" },
                    bottom: { style: "thin" },
                    left: { style: "thin" },
                    right: { style: "thin" }
                }
            };
        }
    });

    // ✅ Auto Width
    ws['!cols'] = header.map(h => ({
        wch: Math.max(h.length + 5, 20)
    }));

    // 👉 Workbook
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Report");

    // 👉 Download
    XLSX.writeFile(wb, "device_Uptime_daily_cumulative_report.xlsx");
},
		downloadcsv2(){
			var self = this;
			var header = new Array()
			self.fields.forEach(function(item){
				if(!item.extra){
					header.push(item.label);
				}
			});
			
			//var d = table.rows().data();
			var finalarr = new Array();
			finalarr.push(header);
			self.records.forEach(function(row){
				var dataarr = new Array();
				self.fields.forEach(function(field){
					if(field.key != 'extra'){
						var fieldData = row[field.key];
						//console.log('field.keyfield.key'+field.key);
						if(field.key =='light_data'){
							var value = row[field.key];
							var threadValue =0;
							if(value!=null && value!='null'){
								var lightData = JSON.parse(value);							
								threadValue =  lightData.thread; 
							}
							fieldData=threadValue;
						}

						if(field.key == 'output_status'){
							
							if(fieldData ==1){
								fieldData = "ON";
							}else{
								fieldData = "OFF";
							}
						}

						if(field.key == 'door_status'){
							if(fieldData ==1){
								fieldData = "OPEN";
							}else{
								fieldData = "CLOSED";
							}
						}


						dataarr.push(fieldData);
					}
				});
				finalarr.push(dataarr);
			});
			
			let csvContent = "data:text/csv;charset=utf-8," 
			+ finalarr.map(e => e.join(",")).join("\n");

			var encodedUri = encodeURI(csvContent);
			var link = document.createElement("a");
			link.setAttribute("href", encodedUri);
			link.setAttribute("download", "device_Uptime_cumulative_report.csv");
			document.body.appendChild(link); // Required for FF

			link.click();
		},
		onWardChangeward(){
			var wardId 		= this.wardfilter.value;
			this.selectedItem.feeder_pillar_no = wardId;
			//if(wardId!='All'){
			
			/* var imeiNolist 	=  this.warddataListarray_imei[wardId];
			var fpnList 	= this.warddataListarray_fon[wardId];
			var arrayImei = imeiNolist.split(',');
			var arrayFpn = fpnList.split(',');
			this.imei_noOptionsfilter=[];
			this.imei_noOptionsfilter.push({'value':'','text':''});
			this.fpn_noOptionsfilter=[];
			this.fpn_noOptionsfilter.push({'value':'','text':''});
			arrayImei.forEach(item=>{
				console.log(item);
				var supList ={'value':item,'text':item};
				this.imei_noOptionsfilter.push(supList);
				
			});

			arrayFpn.forEach(item=>{
				var supList ={'value':item,'text':item};
				this.fpn_noOptionsfilter.push(supList);
				
			}); */



		}
	}
}
</script>
<style>
html {
  min-height: 100%;
}
body {
/*   background-image: url(../assets/home-banner.png) !important; 
  background-repeat: no-repeat;*/
  background-size: cover;
  /* background-position: center center; */
  background-position: bottom;
  background-color: #ff9f432e;
}

.table {
  font-size: small;
}
.table .btn {
  font-size: 12px;
}
.table td,
.table th {
  vertical-align: middle;
}
#my-table-live .thead-dark th {
  color: #fff;
  background-color: #ff9a37;
  border-color: #ff9a37;
}
#my-table-live .first-col {
  border-radius: 20px 0px 0px 0px;
  min-width: 130px;
}
#my-table-live .last-cal {
  border-radius: 0px 20px 0px 0px;
  min-width: 153px;
}
.borderRadius20 {
  border-radius: 20px;
}
.table-responsive {
  border-radius: 20px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.badge{
	font-size: 85%;
}

.text-sm{
	font-size: 13px;
}
.text-md{
	font-size: 16px;
}
.text-lg{
	font-size: 18px;
}
.w-15{
	width: 15%;
}
.w-10{
	width: 10%;
}
.w-20{
	width: 20%;
}
.h-10{
	height: 10px !important;
}
.h-15{
	height: 15px !important;
}
.h-20{
	height: 20px !important;
}


.v-select{
    width:auto ;
    height: auto;
    padding-right: 0.75rem;
    background-image: none;
    padding: 0px;
    border: 0px;

}
/* 
.v-select-toggle {
    height: calc(1.5em + .5rem + 2px);
    padding-top: .25rem;
    padding-bottom: .25rem;
    padding-left: .5rem;
    font-size: .875rem !important;
}

.v-select .custom-select[multiple], .custom-select[size]:not([size="1"]) {
    height: auto;
    padding-right: .75rem;
    background-image: none;
    width: auto;
} */
.customselectfilter button{
  height: 36px;
}
</style>